import Card from '../../../components/ui/Card';
import Skeleton from '../../../components/feedback/Skeleton';

/**
 * Replica la estructura visual de PetCard para evitar layout shift
 * cuando los datos reales reemplazan el skeleton.
 */
const PetCardSkeleton = () => {
  return (
    <Card>
      <div className="flex items-center gap-3">
        <Skeleton variant="circle" width="3.5rem" height="3.5rem" />
        <div className="flex-1 space-y-2">
          <Skeleton variant="text" width="60%" height="1.125rem" />
          <Skeleton variant="text" width="40%" height="0.875rem" />
        </div>
        <Skeleton variant="rect" width="3rem" height="3rem" />
      </div>
    </Card>
  );
};

export default PetCardSkeleton;